import React, { HTMLAttributes } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

interface IDialogFooterProps extends HTMLAttributes<HTMLDivElement> {
  dialogPrefix?: string;
}

interface IDialogFooterStates extends HTMLAttributes<HTMLDivElement> {}

class DialogFooter extends React.Component<
  IDialogFooterProps,
  IDialogFooterStates
> {
  static propTypes: PropTypes.InferProps<IDialogFooterProps>;

  private defaultDialogPrefix = "modal";

  render() {
    const { dialogPrefix, children, className, ...props } = this.props;
    const prefix = dialogPrefix || this.defaultDialogPrefix;
    const headerClassName = cn(className, prefix + "-footer");

    return (
      <div {...props} className={headerClassName}>
        {children}
      </div>
    );
  }
}

export default DialogFooter;
